<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->
<template>
  <g>
    <path
      d="M16.76 1H7.76001V4.88536C7.74146 4.92331 7.72338 4.96152 7.70578 5H5V6H7.37219C7.29736 6.34283 7.25794 6.6989 7.25794 7.06417C7.25794 9.80764 9.48196 12.0317 12.2254 12.0317C14.9689 12.0317 17.1929 9.80764 17.1929 7.06417C17.1929 6.6989 17.1535 6.34283 17.0787 6H19V5H16.76V1Z"
      fill="#211E1E"
    />
    <path
      d="M13.1286 21.0637H5C4.99972 19.9608 5.25192 18.8725 5.73727 17.8822C6.22261 16.8918 6.92823 16.0257 7.80005 15.3502C8.67188 14.6747 9.68676 14.2078 10.7669 13.9852C11.5458 13.8246 12.3437 13.7942 13.1286 13.8931V21.0637Z"
      fill="#211E1E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.7716 16.8692C15.6729 17.2842 15.6729 17.7166 15.7716 18.1316L15 18.5764L15.7778 19.9236L16.5493 19.4779C16.859 19.7712 17.2334 19.9876 17.6421 20.1094V21H19.1977V20.1094C19.6064 19.9876 19.9808 19.7712 20.2904 19.4779L21.062 19.9236L21.8398 18.5764L21.0682 18.1308C21.1667 17.716 21.1667 17.284 21.0682 16.8692L21.8398 16.4236L21.062 15.0764L20.2904 15.5221C19.9848 15.2328 19.6114 15.0134 19.1977 14.8906V14H17.6421V14.8906C17.2334 15.0124 16.859 15.2288 16.5493 15.5221L15.7778 15.0764L15 16.4236L15.7716 16.8692ZM17.8699 16.95C18.0158 16.8041 18.2136 16.7222 18.4199 16.7222C18.6261 16.7222 18.824 16.8041 18.9698 16.95C19.1157 17.0958 19.1976 17.2937 19.1976 17.4999C19.1976 17.7062 19.1157 17.9041 18.9698 18.0499C18.824 18.1958 18.6261 18.2777 18.4199 18.2777C18.2136 18.2777 18.0158 18.1958 17.8699 18.0499C17.724 17.9041 17.6421 17.7062 17.6421 17.4999C17.6421 17.2937 17.724 17.0958 17.8699 16.95Z"
      fill="#211E1E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.7716 16.8692C15.6729 17.2842 15.6729 17.7166 15.7716 18.1316L15 18.5764L15.7778 19.9236L16.5493 19.4779C16.859 19.7712 17.2334 19.9876 17.6421 20.1094V21H19.1977V20.1094C19.6064 19.9876 19.9808 19.7712 20.2904 19.4779L21.062 19.9236L21.8398 18.5764L21.0682 18.1308C21.1667 17.716 21.1667 17.284 21.0682 16.8692L21.8398 16.4236L21.062 15.0764L20.2904 15.5221C19.9848 15.2328 19.6114 15.0134 19.1977 14.8906V14H17.6421V14.8906C17.2334 15.0124 16.859 15.2288 16.5493 15.5221L15.7778 15.0764L15 16.4236L15.7716 16.8692ZM17.8699 16.95C18.0158 16.8041 18.2136 16.7222 18.4199 16.7222C18.6261 16.7222 18.824 16.8041 18.9698 16.95C19.1157 17.0958 19.1976 17.2937 19.1976 17.4999C19.1976 17.7062 19.1157 17.9041 18.9698 18.0499C18.824 18.1958 18.6261 18.2777 18.4199 18.2777C18.2136 18.2777 18.0158 18.1958 17.8699 18.0499C17.724 17.9041 17.6421 17.7062 17.6421 17.4999C17.6421 17.2937 17.724 17.0958 17.8699 16.95Z"
      fill="#663CDC"
    />
  </g>
</template>
